// extracted by mini-css-extract-plugin
export default {"imgdiv":"a6ad7a4503 _3aeaac5059","img":"a10ea3dce3 _887b539dae"};